async function fetchAllProductCards(productHandles, targetContainer, sectionRecently, sectionRelated) {
  sectionRecently.style.display = "none";
  sectionRelated.style.display = "none";

  try {
    const fetchPromises = productHandles.slice(1, productsToShow+1).map(async (handle) => {
      const response = await fetch(`/products/${handle}/?sections=card-product`);
      const text = await response.json();
      let cardHtml = text["card-product"];

      if (cardHtml.includes("Example product title")) {
        localStorage.setItem("viewedProducts", JSON.stringify(JSON.parse(localStorage.getItem("viewedProducts")).filter(product => product.handle !== handle)));
        console.log(`Removed problematic handle: ${handle}`);
        throw new Error(`Product card fetch failed for ${handle}: Received fallback content.`);
      }

      cardHtml = cardHtml.replace(/<link[^>]*>/g, "");

      return `<li class="grid__item">${cardHtml}</li>`;
    });

    const cardsHtml = await Promise.all(fetchPromises);

    targetContainer.innerHTML += `${cardsHtml.join("")}`;

    document.querySelectorAll(".grid__item #card-production").forEach((div) => {
      div.style.display = "block";
    });

    sectionRecently.style.display = "block";

  } catch (error) {
    console.error(`Error fetching product cards:`, error);
    
    sectionRelated.style.display = "block";
    targetContainer.innerHTML = `<p class="error-message">Could not load recently viewed products.</p>`;
  }
}

document.addEventListener("DOMContentLoaded", async function () {
  let viewedProducts = JSON.parse(localStorage.getItem("viewedProducts")) || [];
  const sectionRecently = document.getElementById("recently-viewed");
  const sectionRelated = document.querySelector(".related-products");
  const container = document.getElementById("recently-viewed-list");

  if (!container || viewedProducts.length < 2) {
    sectionRecently.style.display = "none";
    sectionRelated.style.display = "block";
    return;
  }

  const productHandles = viewedProducts.map((product) => product.handle);
  fetchAllProductCards(productHandles, container, sectionRecently, sectionRelated);
});
